import { Chip } from '@mui/material';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { IOrderError } from '../../../types/api/response/ordererrorsresponse';

const dependencyColor = (dependency: string | null): 'default' | 'warning' | 'info' | 'error' => {
  switch (dependency) {
    case 'CIN7':
      return 'warning';
    case 'LOCUS':
      return 'info';
    case 'PAYMENT_GATEWAY':
      return 'error';
    default:
      return 'default';
  }
};

export const getOrderErrorsColumns = (): GridColDef[] => [
  {
    field: 'created_at',
    headerName: 'Timestamp',
    flex: 1.2,
    valueFormatter: (value: string) => (value ? new Date(value).toLocaleString() : '—'),
  },
  {
    field: 'reference',
    headerName: 'Order Reference',
    flex: 1,
    valueGetter: (_, row: IOrderError) => row.ds_order_number ?? row.order_number ?? '—',
  },
  {
    field: 'stage',
    headerName: 'Stage',
    flex: 1,
    renderCell: ({ value }: GridRenderCellParams) => (
      <Chip label={value} size="small" variant="outlined" />
    ),
  },
  {
    field: 'dependency',
    headerName: 'Dependency',
    flex: 0.9,
    renderCell: ({ value }: GridRenderCellParams) =>
      value ? <Chip label={value} size="small" color={dependencyColor(value)} /> : '—',
  },
  {
    field: 'error_code',
    headerName: 'Error Code',
    flex: 0.7,
    valueFormatter: (value: string | null) => value ?? '—',
  },
  {
    field: 'user_phone',
    headerName: 'Phone',
    flex: 0.9,
    valueFormatter: (value: string | null) => value ?? '—',
  },
  {
    field: 'message',
    headerName: 'Message',
    flex: 2,
  },
];
